import styled, { css } from "styled-components";
import { alpha } from "../../typography";
import { PillVariant } from "./types";

type PillType = "PRIMARY" | "SECONDARY" | "ERROR" | "WARNING" | "SUCCESS";

type Colors = {
  color: string;
  bgColor: string;
};

type VariantsWithColors = {
  [Variant in PillVariant]: Colors;
};

type PillColors = {
  [Type in PillType]: VariantsWithColors;
};

const colors: PillColors = {
  PRIMARY: {
    DEFAULT: {
      color: "var(--color-neutral-000-full)",
      bgColor: "var(--color-primary-500)",
    },
    INACTIVE: {
      color: "var(--color-primary-900)",
      bgColor: "var(--color-primary-100)",
    },
  },
  SECONDARY: {
    DEFAULT: {
      color: "var(--color-neutral-000-full)",
      bgColor: "var(--color-secondary-800)",
    },
    INACTIVE: {
      color: "var(--color-secondary-800)",
      bgColor: "var(--color-secondary-200)",
    },
  },
  ERROR: {
    DEFAULT: {
      color: "var(--color-neutral-000-full)",
      bgColor: "var(--color-error-500)",
    },
    INACTIVE: {
      color: "var(--color-error-700)",
      bgColor: "var(--color-error-100);",
    },
  },
  WARNING: {
    DEFAULT: {
      color: "var(--color-neutral-000-full)",
      bgColor: "var(--color-warning-500)",
    },
    INACTIVE: {
      color: "var(--color-warning-800)",
      bgColor: "var(--color-warning-100)",
    },
  },
  SUCCESS: {
    DEFAULT: {
      color: "var(--color-neutral-000-full)",
      bgColor: "var(--color-success-500)",
    },
    INACTIVE: {
      color: "var(--color-success-800)",
      bgColor: "var(--color-success-100)",
    },
  },
};

export const StyledBasePill = styled.div<Colors>`
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 20px;
  padding: 2px 8px;
  border-radius: var(--size-border-radius-large);
  ${alpha.primaryActive.body3};
  ${(props) => css`
    color: ${props.color};
    background-color: ${props.bgColor};
    border: 1px solid ${props.bgColor};
  `}
`;

type BasePillProps = {
  type: PillType;
  variant: PillVariant;
  className?: string;
  testId?: string;
  id?: string;
};

export const BasePill: React.FC<BasePillProps> = ({
  children,
  type,
  variant,
  ...props
}) => {
  const applicableColors = colors[type][variant];

  return (
    <StyledBasePill {...props} {...applicableColors}>
      {children}
    </StyledBasePill>
  );
};
